/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../services/account.service';
import { ResetPasswordComponent } from './accounts/reset-password.component';
import { LoginModalComponent } from './modals/login-modal.component';
import { XdaStringsService } from '../services/xda-strings.service';
import { MyAccountComponent } from './accounts/my-account.component';
import { Location } from '@angular/common';
import { ErrorService } from '../services/error.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less', '../../styles/appTheme-xids.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private activatedroute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private location: Location,
    private accountService: AccountService,
    private xdaStringsService: XdaStringsService,
    private errorService: ErrorService,
  ) {
    if (window.location.href.toLowerCase().includes('xeroxtranslates')) {
      this.translateRedirect();
    } else {
      const refreshToken = this.activatedroute.snapshot.paramMap.get('token');
      const authCode = this.activatedroute.snapshot.queryParamMap.get('authCode') || "";
      if (refreshToken || authCode) {
        const action = this.activatedroute.snapshot.paramMap.get('action');
        this.loginAndRedirect(refreshToken, authCode, action);
        }
     
      //password reset params from email
      this.activatedroute.queryParams.subscribe((params) => {
        const resetToken = params['resetToken'];
        const email = params['email'];
        const type = params['type'];
        const resetDate = params['resetDate'];
        if (resetToken) {
          this.validateResetLink(resetToken, email, type, resetDate);
        }
      });
    }
  }

  ngOnInit(): void {
    const currentState = this.location.getState() as any;
    if (currentState.displayLogin) {
      this.getStarted();
    }
  }

  translateRedirect() {
    window.location.href = this.xdaStringsService.strings['APPBASEURL'];
  }

  async loginAndRedirect(refreshToken: string | null, authCode: string, action: string | null) {
    if (this.userService.user) {
      this.userService.logOff(false);
    }

    refreshToken ?
      await this.userService.refreshToken(refreshToken) :
      await this.userService.exchangeAuthCode(authCode);
    if (this.userService.user) {
      this.userService.editAGAccountIfRequired();

      if (action === 'edit') {
        const modalRef = this.modalService.open(MyAccountComponent, {
          windowClass: 'xrx-modal',
        });
        modalRef.result.then(
          () => {},
          (dismissReason) => {
            if (dismissReason == 'navigating') {
              //If modal is dismissed from navigation just re-open it
              this.modalService.open(MyAccountComponent, {
                windowClass: 'xrx-modal',
              });
            }
          },
        );
      } else if (action === 'create') {
        this.router.navigate(['/workflows']);
      }
    }
  }

  async validateResetLink(
    resetToken: string,
    email: string,
    type: string,
    resetDate: string,
  ) {
    try {
      await this.accountService.validateResetLink(email, type, resetDate);
      const modalRef = this.modalService.open(ResetPasswordComponent, {
        windowClass: 'xrx-modal',
      });
      modalRef.componentInstance.resetObj = {
        token: resetToken,
        email: email,
        resetType: type,
      };
    } catch (error) {
      console.log(error);
      this.errorService.displayGeneralError();
    }
  }

  getStarted() {
    this.modalService.open(LoginModalComponent, { windowClass: 'xrx-modal' });
  }

  learnMore(button: string) {
    let url = '';
    switch (button) {
      case 'hero':
      case 'drive':
      case 'access':
        url = 'https://www.xerox.com/WorkflowCentral';
        break;
      case 'automated':
        url =
          'https://www.xerox.com/en-us/office/software-solutions/workflow-central/task-automation';
        break;
    }

    window.open(url, '_blank');
  }

  tryIt() {
    const url = this.xdaStringsService.strings['AGTRYITURL'];
    window.location.href = url;
  }
}
